import React from 'react';
import queryString from 'query-string';
import { Form, Progress, Alert } from 'reactstrap';
import { CSSTransition } from 'react-transition-group';

import { WithLocalize } from '../../containers/I18nProvider';
import { WithCaptcha } from '../../containers/captcha';

/**
 * Login Form Container
 *
 * @class LoginForm
 * @extends {React.Component}
 */
class LoginForm extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.parameters = queryString.parse(props.location.search);
    this.parameters.idp = 'watch';
    this.ref = React.createRef();
    this.state = {
      onLogin: false,
      showForm: false,
      error: {
        open: false,
        message: ''
      },
      username: '',
      password: ''
    };
  }

  componentDidMount() {
    this.setState({ showForm: true });
  }

  onError(error) {
    this.setState({
      error: {
        open: true,
        message: error.message
      }
    });
  }

  async onSubmit(ev) {
    ev.preventDefault();

    this.setState({
      onLogin: true,
      error: {
        open: false,
        message: ''
      }
    });



    this.props.api.userPassLogin(
      {
        username: this.usernameInput.value,
        cp_convert: this.parameters.cp_convert,
        password: this.passwordInput.value,
      }, this.parameters

    )
      .then((response) => {
        this.setState({ onLogin: false });
        window.location = this.parameters.redirect_uri + '?' + queryString.stringify(response);
      })
      .catch(error => {
        const translate = this.props.translate(error.errorCode);

        let message = 'Occurrió un error.';

        if (translate) {
          message = translate;
        } else if (error.details) {
          message = error.details;
        }
        this.setState({ onLogin: false, error: { open: true, message: message } });
      });
  }

  render() {
    const { translate } = this.props;

    return (
      <CSSTransition
        in={this.state.showForm}
        timeout={300}
        classNames="formshow"
        nodeRef={this.ref}
        unmountOnExit
      >
        <div className="login-watch-container" ref={this.ref}>
          <Form onSubmit={event => this.onSubmit(event)}>
            <p className="description-watch">Login</p>
            <label className="label-watch">{translate('PlaceholderUserName')}</label>
            <input
              className="user-input-watch"
              disabled={this.state.onLogin}
              ref={(ref) => {
                this.usernameInput = ref;
              }
              }
              required={true}
              tabIndex={1}
              type="text"
              autoCorrect="off"
              autoCapitalize="none"
              name="username"
            />
            <label className="label-watch">{translate('PlaceholderPassword')}</label>
            <input
              className="user-input-watch"
              required={true}
              disabled={this.state.onLogin}
              ref={(ref) => {
                this.passwordInput = ref;
              }
              }
              tabIndex={1}
              type="password"
              autoCorrect="off"
              autoCapitalize="none"
              name="password"
            />
            <div>
              {!this.state.onLogin ?
                <button
                  block={!this.parameters.failureRedirect}
                  tabIndex={1}
                  className="enter-watch"
                  type="submit"
                  name="submit"
                  disabled={!this.props.turnstileSuccess}
                >
                  {translate('ButtonEnter')}
                </button> :
                <Progress animated color="danger" value={100} />}
            </div>
            <div className="messages-container">
              <Alert color="danger" id="error-message" isOpen={this.state.error.open} toggle={() => this.setState({ error: { open: false } })}>
                {this.state.error.message}
              </Alert>
            </div>
            <this.props.TurnstileComponent setTurnstileSuccess={this.props.setTurnstileSuccess} />
          </Form>
        </div>
      </CSSTransition>
    );
  }
}

export default WithCaptcha(WithLocalize(LoginForm), { useInsideForm: true, style: { marginTop: '2rem' } });
